import { NATIONAL_ID_FORMATS } from '../../constants/nationalId'
import type { NationalIdCountries } from '../../types/nationalId'

export function getNationalIdFormat(country: NationalIdCountries) {
  return NATIONAL_ID_FORMATS[country]
}
